import moment from 'moment';
import PRODUCT_TYPE from './ProductType';

export const getIdsOfItems = (hiredProduct, productType) => {
  const idsArray = [];
  // 1) mobiles
  const productHasMobile = productType === 0 || productType === 3;
  const productHasMobile1 = hiredProduct.mobile !== null;

  if (productHasMobile && productHasMobile1) {
    const { linesMobile } = hiredProduct.mobile;

    linesMobile.map((currentLines) => {
      const kindProduct = 'mobile';
      const res = {
        kindProduct,
        number: currentLines.number,
        productId: currentLines.productId,
      };

      idsArray.push(res);
      return null;
    });
  }
  // 2) internet
  const productHasInternet =
    productType === 0 || productType === 1 || productType === 2;
  const productHasInternet1 = hiredProduct.internet !== null;

  if (productHasInternet && productHasInternet1) {
    const kindProduct = 'internet';
    const res = {
      kindProduct,
      productId: hiredProduct.internet.productId,
    };

    idsArray.push(res);
  }
  // phone
  const productHasPhone =
    (productType >= 0 && productType < 3) || productType === 4;
  const productHasPhone1 = hiredProduct.phone !== null;

  if (productHasPhone && productHasPhone1) {
    const { linesPhone } = hiredProduct.phone;

    linesPhone.map((currentLines) => {
      const kindProduct = 'phone';
      const res = {
        kindProduct,
        number: currentLines.number,
        productId: currentLines.productId,
      };

      idsArray.push(res);
      return null;
    });
  }
  // tv ¿y el trio?
  const productHasTv = productType === 0;
  const productHasTv1 = hiredProduct.tv !== null;

  if (productHasTv && productHasTv1) {
    const kindProduct = 'tv';
    const res = {
      kindProduct,
      productId: hiredProduct.tv.productId,
    };

    idsArray.push(res);
  }
  return idsArray;
};

export const getAllDataItems = (hiredProduct) => {
  const idsArray = getIdsOfItems(hiredProduct, hiredProduct.productType);

  return idsArray;
};

export const normalizeGetMyProductsResponse = (myProducts) => {
  const myProductsNew = [];

  myProducts.forEach((product) => {
    const newProductObj = product;

    let newLinesMobile = null;

    if (product.mobile && product.mobile.linesMobile) {
      newLinesMobile = product.mobile.linesMobile.map((itemMobile) => {
        const newItemLineMobile = itemMobile;

        newItemLineMobile.main = false;
        return newItemLineMobile;
      });
    }
    if (newLinesMobile) {
      newProductObj.mobile.linesMobile = newLinesMobile;
    }
    const ids2Add = getAllDataItems(product);
    const newProduct = newProductObj;

    newProduct.childProductId = ids2Add;

    myProductsNew.push(newProduct);
  });
  return myProductsNew;
};

const isDateGreaterThanSixMonthsAgo = (dateUTC: string) => {
  const sixMonthAgo = moment().subtract(6, 'months').toDate();
  const mobileStartDate = new Date(dateUTC);
  return mobileStartDate > sixMonthAgo;
};

export const normalizeGetMyLinesResponse = (
  myProducts,
  allowRecentMobileLines: boolean,
  retryAllMobileLines: boolean,
): { linesMobile: unknown[]; linesPhone: unknown[] } => {
  const lines = {
    linesMobile: [],
    linesPhone: [],
  };

  myProducts.forEach((product) => {
    switch (product.productType) {
      case PRODUCT_TYPE.FUSION: {
        product.phone.linesPhone.forEach((line) => {
          line.productType = product.productType;
          line.isPack = true;
          lines.linesPhone.push(line);
        });
        if (retryAllMobileLines) {
          product.mobile.linesMobile.forEach((line) => {
            line.productType = product.productType;
            line.isPack = true;
            lines.linesMobile.push(line);
          });
        } else {
          // Sólo obtenemos la línea móvil más antigua
          let oldLineMobile = product.mobile.linesMobile[0];

          product.mobile.linesMobile.forEach((line) => {
            if (new Date(oldLineMobile.startDate) > new Date(line.startDate)) {
              oldLineMobile = line;
            }
          });
          oldLineMobile.productType = product.productType;
          oldLineMobile.isPack = true;

          if (
            allowRecentMobileLines ||
            !isDateGreaterThanSixMonthsAgo(oldLineMobile.startDate)
          ) {
            lines.linesMobile.push(oldLineMobile);
          }
        }
        break;    
      }
      case PRODUCT_TYPE.TRIO:
      case PRODUCT_TYPE.DUO:
        product.phone.linesPhone.forEach((line) => {
          line.productType = product.productType;
          lines.linesPhone.push(line);
        });
        break;
      case PRODUCT_TYPE.ONLY_MOBILE_LINE:
        product.mobile.linesMobile.forEach((line) => {
          if (
            allowRecentMobileLines ||
            !isDateGreaterThanSixMonthsAgo(line.startDate)
          ) {
            line.productType = product.productType;
            lines.linesMobile.push(line);
          }
        });
        break;
      default:
        break;
    }
  });
  return lines;
};
